import { type IconifyProps } from '../../components/iconify/types';

const CrispIcon: IconifyProps = {
    body: '<path fill="currentColor" d="M28.81,44.405l-19.3,2.2l-3.16,-32.88l54.14,-6.24l3.16,32.92l-18.74,2.14l-7,11.44l-9.1,-9.6l0,0.02Z" />',
    height: 60,
    width: 70,
};

export default CrispIcon;
